import React, { PropTypes } from 'react';
import EstablishmentsRow from './EstablishmentsRow';

const EstablishmentsTable = ({
  establishments,
  onSelectAll,
  onSelect,
  selectAllChecked,
  selectedEstablishments,
  hideStatus
}) => {
  const renderHeader = () => (
    <tr>
      <th>
        <input
          type="checkbox"
          name="submit-reports-all"
          onChange={onSelectAll}
          checked={selectAllChecked}
        />
      </th>
      {!hideStatus && <th>300A Status</th>}
      {!hideStatus && <th>300/301 Status</th>}
      <th>Name</th>
      <th className="non-mobile">Street</th>
      <th className="non-mobile">City</th>
      <th className="non-mobile">State</th>
      <th className="non-mobile">Zip Code</th>
      <th className="non-mobile">EIN</th>
    </tr>
  );

  const renderRows = () =>
    establishments.map((establishment, index) => (
      <EstablishmentsRow
        establishment={establishment}
        key={establishment.id}
        onSelect={onSelect}
        isSelected={!!selectedEstablishments[establishment.id]}
        evenRow={index % 2 === 0}
        hideStatus={hideStatus}
      />
    ));

  return establishments.length !== 0 ? (
    <div className="establishment-container non-mobile">
      <table className="table">
        <thead>{renderHeader()}</thead>
        <tbody>{renderRows()}</tbody>
      </table>
    </div>
  ) : (
    <div className="establishment-container non-mobile">
      There are no available establishment records for this filter combination. Please either try filtering again or adding an establishment.
    </div>
  );
};

EstablishmentsTable.propTypes = {
  establishments: PropTypes.array.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selectAllChecked: PropTypes.bool.isRequired,
  selectedEstablishments: PropTypes.object.isRequired,
  hideStatus: PropTypes.bool
};

export default EstablishmentsTable;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/EstablishmentsTable/EstablishmentsTable.js
 **/